module.exports = __webpack_public_path__ + "img/Ellipse5.7dc0c0f5.png";